import React from 'react'

function Header({ handleOpen }) {
    return (
        <header id="header" className="site-header home-header home-header-while header-land">
            <div className="container">
                <div className="row header-width" >
                    <div className="main-menu-wrapper">
                        <div className="menu-header">
                            <a href="/" className="menu-logo">
                                <img src="assets/img/logo.png" className="img-fluid" alt="Logo" />
                            </a>
                            <a id="menu_close" className="menu-close" >
                                <i className="fas fa-times text-primary"></i>
                            </a>
                        </div>
                        <ul className="main-nav bg-trans">
                            <li>
                                <a href="#products">Products</a>
                            </li>
                            <li>
                                <a href="#features">Features</a>
                            </li>
                            <li>
                                <a href="#pricing">Pricing</a>
                            </li>
                            <li>
                                <a href="#contactus">Contact US</a>
                            </li>

                        </ul>
                        <div className="try-free link mobile-head-menu">
                            <button
                                onClick={() => {
                                    handleOpen(true)
                                }}
                                type='button' className="req-btn"  >
                                Request Demo
                                <svg width="18" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
                            </button>
                        </div>
                    </div>
                    <div className="main-menu-head d-flex justify-content-between">
                        <div className='d-flex w-100 align-items-center' style={{gap:"40px"}} >
                        <div className="res-center ">
                            <div className="site">
                                <a id="mobile_btn" >
                                    <span className="bar-icon-second text-primary">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </span>
                                </a>
                                <div className="site-brand">
                                    <a href="/" className="site-branding-logo"><img src="assets/img/logo.png" alt="logo" className="img-fluid" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="menu-list">
                            <div className="right-header d-flex justify-content-center">
                                <nav className="land-menu">
                                    <ul>
                                        <li><a href="#products" className="scrollTo">Products</a></li>
                                        <li><a href="#features" className="scrollTo">Features</a></li>
                                        <li><a href="#pricing" className="scrollTo">Pricing</a></li>
                                        <li>
                                            <a href="#contactus">Contact Us</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        </div>
                        <div className="home-buy-button">
                            <div className="buy-btns">
                                <button onClick={() => {
                                    handleOpen()
                                }} className='req-btn'>
                                    Request Demo
                                    <svg width="18" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
